














import { Action } from 'vuex-class'
import { Prop, Component } from 'vue-property-decorator'
import _ from 'lodash'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ISchedule } from '@/store/modules/views/schedule/states'

@Component
export default class ConfirmDeleteWorkDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private scheduleId!: string
  @Prop() private schduleDate!: string
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deleteJobDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ยืนยัน',
          action: this.deleteJobAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  @Action('schedule/putStopSchedule')
  private putStopSchedule!: (options: {}) => Promise<void>

  private async deleteJobAction() {
    this.loading = true
    try {
      await this.putStopSchedule({
        id: this.scheduleId,
      })
      this.updateSnackbar({txt: 'ลบงานออกจากตารางสำเร็จ', type: 'success'})
      this.$emit('confirm', this.schduleDate)
      await this.callback()
      this.closeDialog()
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
